<template>
  <modal :name="modalName" :click-to-close="true" :height="'auto'" :scrollable="true">
    <v-modal-content v-on:close="close" :title="modalMode === 'add' ? loc('addWarrantyRegistration') : loc('editWarrantyRegistration') ">
      <v-form :fields="fields" :form-data="formData" :form-errors="formErrors">
        <div slot="buttons">
          <button class="btn btn--cancel" type="button" v-on:click="close">{{loc('cancel')}}</button>
          <button :disabled="processing" v-if="modalMode === 'add'" type="submit" v-on:click="addWarrantyRegistration" class="btn btn--white">{{loc('addWarrantyRegistration')}}</button>
        </div>
      </v-form>
    </v-modal-content>
  </modal>
</template>

<script>

import VModalContent from './v-modal-content.vue';
import VForm from './v-form.vue';

export default {
  components: {
    'v-modal-content': VModalContent,
    'v-form': VForm
  },
  name: 'ModalWarrantyRegistration',
  props: ['on-close', 'modal-mode', 'modal-data'],
  data: function() {
    return {
      formErrors: {},
      formData: {},
      data: {},
      name: 'warranty-registration',
      processing: false
    }
  },
  computed: {
    fields() {
      return this.getFields();
    },
    modalName() {
      return this.name + '-' + this.modalMode;
    }
  },
  methods: {
    increaseShowCount() {
      this.showCount++;
    },
    applyModalData() {
      this.formErrors = {};
      this.formData = {};
      this.data = {};

      if(this.$props.modalData) {
        Object.keys(this.$props.modalData).forEach(key => {
          this.data[key] = this.$props.modalData[key];
        });
      }

      this.increaseShowCount();
    },
    getFields() {
      // Initialize form depending on modal mode
      if(this.$props.modalMode === 'add') {
        return [{
            name: 'machineInfoHeading',
            heading: this.loc('machineInformation'),
            type: 'heading'
          },
          {
          name: 'serialNumber',
          value: this.data.serialNumber,
          label: this.loc('serialNumber')+' *',
          type: 'text'
        },
        {
          name: 'machine',
          value: this.data.machine,
          label: this.loc('machineModel')+' *',
          type: 'text'
        },
        {
          name: 'moreMachines',
          label: this.loc('forms.labels.addMoreMachines'),
          type: 'data-items',
          hideEmpty: true,
          addBtnText: this.loc('addNew'),
          value: [],
          fields: [
          {
            name: 'serialNumber',
            value: this.data.serialNumber,
            label: this.loc('serialNumber')+' *',
            type: 'text'
          },
          {
            name: 'machine',
            value: this.data.machine,
            label: this.loc('machineModel')+' *',
            type: 'text'
          }]
        },
        {
          name: 'customerInformationHeading',
          heading: this.loc('customerInformation'),
          type: 'heading'
        },
        {
          name: 'customerFirstname',
          value: this.data.customerFirstname,
          label: this.loc('firstName')+' *',
          type: 'text'
        },
        {
          name: 'customerLastname',
          value: this.data.customerLastname,
          label: this.loc('lastName')+' *',
          type: 'text'
        },
        {
          name: 'customerEmail',
          value: this.data.customerEmail,
          label: this.loc('email')+' *',
          type: 'email'
        },
        {
          name: 'customerPhone',
          value: this.data.customerPhone,
          label: this.loc('phone'),
          type: 'text'
        },
        {
          name: 'deliveryDate',
          value: this.data.deliveryDate,
          label: this.loc('deliveryDateSold')+' *',
          type: 'date'
        },
        {
          name: 'customerNumber',
          value: this.data.customerNumber,
          label: this.loc('warrantyCustomerNumber'),
          type: 'text'
        },
        {
          name: 'customerCompanyNumber',
          value: this.data.customerCompanyNumber,
          label: this.loc('companyNumber'),
          type: 'text'
        },
        {
          name: 'sellerInformationHeading',
          heading: this.loc('sellerInformation'),
          type: 'heading'
        },
        {
          name: 'sellerFirstname',
          value: this.$store.state.user.info.firstName,
          label: this.loc('firstName')+' *',
          type: 'text'
        },
        {
          name: 'sellerLastname',
          value: this.$store.state.user.info.lastName,
          label: this.loc('lastName')+' *',
          type: 'text'
        },
        {
          name: 'sellerEmail',
          value: this.$store.state.user.info.username,
          label: this.loc('email')+' *',
          type: 'email'
        },
        {
          name: 'sellerStore',
          value: this.$store.state.user.company.name,
          label: this.loc('store')+' *',
          type: 'text'
        },
        {
          name: 'sellerBusinessId',
          value: this.$store.state.user.company.businessId,
          label: this.loc('businessId'),
          type: 'text'
        },
        {
          name: 'sellerStreetAddress',
          value: this.$store.state.user.company.address,
          label: this.loc('address'),
          type: 'text'
        },
        {
          name: 'sellerPostalCode',
          value: this.$store.state.user.company.postalCode,
          label: this.loc('postalCode'),
          type: 'text'
        },
        {
          name: 'sellerPostalArea',
          value: this.$store.state.user.company.postOffice,
          label: this.loc('postOffice'),
          type: 'text'
        },
        {
          name: 'receivedWarrantyDocumentsHeading',
          heading: this.loc('receivedWarrantyDocuments'),
          type: 'heading'
        },
        {
          name: 'manualReceived',
          value: this.data.manualReceived,
          label: this.loc('components.warrantyRegistrations.warrantyManual')+' *',
          type: 'bool'
        },
        {
          name: 'ceEDeclarationReceived',
          value: this.data.ceEDeclarationReceived,
          label: this.loc('components.warrantyRegistrations.ceEDeclaration')+' *',
          type: 'bool'
        },
        {
          name: 'sparePartsListReceived',
          value: this.data.sparePartsListReceived,
          label: this.loc('components.warrantyRegistrations.sparePartsList')+' *',
          type: 'bool'
        },
        /*
        {
          name: 'maintenanceBookletReceived',
          value: this.data.maintenanceBookletReceived,
          label: this.loc('components.warrantyRegistrations.maintenanceBooklet')+' *',
          type: 'bool'
        }, */ //removed per client request 7.10.2019 (basecamp, Lammi)
        {
          name: 'emptyHeading1',
          heading: ' ',
          type: 'heading'
        },
        {
          name: 'contactAllowed',
          value: this.data.contactAllowed,
          label: this.loc('components.warrantyRegistrations.contactAllowed')+' *',
          type: 'bool'
        },
        {
          name: 'newsletter',
          value: this.data.newsletter,
          label: this.loc('orderNewsletter'),
          type: 'bool'
        },
        {
          name: 'collectDataFromFactoryConnection',
          value: this.data.collectDataFromFactoryConnection,
          label: `${this.loc('collectDataFromFactoryConnection')}  * `,
          help: `${this.loc('privacyPageLink')} `,
          type: 'bool'
        }
        ]
      } else if(this.$props.modalMode === 'edit') {
        // Not yet implemented
      }
    },
    show() {
      this.applyModalData();
      this.$modal.show(this.modalName);
    },
    close(data) {
      if(this.onClose) {
        if(!data) {
          data = {
            status: 'cancel'
          };
        }
        this.onClose(data);
      }
      this.$modal.hide(this.modalName);
    },
    async addWarrantyRegistration() {
      this.processing = true;

      let res = await this.$api.addWarrantyRegistration({
        serialNumber: this.formData.serialNumber,
        machine: this.formData.machine,
        moreMachines: this.formData.moreMachines,
        customerFirstname: this.formData.customerFirstname,
        customerLastname: this.formData.customerLastname,
        customerEmail: this.formData.customerEmail,
        customerPhone: this.formData.customerPhone,
        deliveryDate: this.formData.deliveryDate,
        customerNumber: this.formData.customerNumber,
        customerCompanyNumber: this.formData.customerCompanyNumber,
        sellerFirstname: this.formData.sellerFirstname,
        sellerLastname: this.formData.sellerLastname,
        sellerEmail: this.formData.sellerEmail,
        sellerStore: this.formData.sellerStore,
        sellerBusinessId: this.formData.sellerBusinessId,
        sellerStreetAddress: this.formData.sellerStreetAddress,
        sellerPostalCode: this.formData.sellerPostalCode,
        sellerPostalArea: this.formData.sellerPostalArea,
        manualReceived: this.formData.manualReceived,
        ceEDeclarationReceived: this.formData.ceEDeclarationReceived,
        sparePartsListReceived: this.formData.sparePartsListReceived,
        maintenanceBookletReceived: this.formData.maintenanceBookletReceived,
        contactAllowed: this.formData.contactAllowed,
        newsletter: this.formData.newsletter,
        collectDataFromFactoryConnection: this.formData.collectDataFromFactoryConnection
      })

      if(res.code === 400) {
        this.formErrors = res.result.fields;
        this.processing = false;
        return;
      }

      if(res.code !== 200) {
        this.processing = false;
        return;
      }

      const warrantyRegistration = res.result.warrantyRegistration;
      const warrantyRegistrationId = res.result.warrantyRegistration.uuid;

      // Save state of a warranty registration
      this.$store.commit('addWarrantyRegistration', warrantyRegistration);

      // And trigger fetching of full warranty registration
      this.$store.dispatch('getWarrantyRegistration', warrantyRegistrationId);

      this.processing = false;
      this.close({status: 'success'});
    }
  },
  watch: {
    modalData() {
      this.applyModalData();
    }
  }
}
</script>
